/** @deprecated Use button type from Skapa instead. */
var ButtonOverlayColorEnum;
(function (ButtonOverlayColorEnum) {
    ButtonOverlayColorEnum["IMAGE_OVERLAY_DARKEST"] = "IMAGE_OVERLAY_DARKEST";
    ButtonOverlayColorEnum["IMAGE_OVERLAY_COLOR"] = "IMAGE_OVERLAY_COLOR";
    ButtonOverlayColorEnum["IMAGE_OVERLAY_DARK"] = "IMAGE_OVERLAY_DARK";
    ButtonOverlayColorEnum["BUTTON_COLOR_DARK"] = "BUTTON_COLOR_DARK";
    ButtonOverlayColorEnum["BUTTON_COLOR_LIGHT"] = "BUTTON_COLOR_LIGHT";
    ButtonOverlayColorEnum["BUTTON_COLOR_LIGHT_DARK"] = "BUTTON_COLOR_LIGHT_DARK";
    ButtonOverlayColorEnum["BUTTON_COLOR_SECONDARY_INVERSE"] = "BUTTON_COLOR_SECONDARY_INVERSE";
    ButtonOverlayColorEnum["BUTTON_COLOR_SECONDARY"] = "BUTTON_COLOR_SECONDARY";
})(ButtonOverlayColorEnum || (ButtonOverlayColorEnum = {}));
export default ButtonOverlayColorEnum;
//# sourceMappingURL=ButtonOverlayColorEnum.js.map